<template>
  <div class="corporate-home">
    <!-- Navbar -->
    <CorporateNavbar />
    
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-content">
        <div class="hero-text">
          <h1 class="hero-title">Modern Kurs</h1>
          <p class="hero-subtitle">Eğitimde Modern Olmak Zamanı</p>
          <p class="hero-description">Modern Kurs, öğrencilerini geleceğe hazırlayan yenilikçi bir eğitim kurumudur. Güvenilir, kaliteli ve başarı odaklı eğitim programlarımızla her öğrencimizin yanında. Amacımız sadece sınav kazandırmak değil, güçlü bir gelecek için sağlam bir temel atmaktır.</p>
          <div class="hero-actions">
            <router-link to="/contact" class="btn btn-outline">
              Hemen İletişime Geç
            </router-link>
            <router-link to="/about" class="btn btn-outline">
              Hakkımızda
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Gallery Section -->
    <section class="gallery-section">
      <div class="container">
        <div class="section-header">
          <h2>🏛️ Modern Kurs Merkezi</h2>
          <p>Eğitim kalitesi ve modern teknoloji bir arada</p>
        </div>
        <div class="gallery-grid">
          <div class="gallery-item">
            <img src="@/assets/images/2.jpeg" alt="ModernKurs Merkezi 2" class="gallery-image">
          </div>
          <div class="gallery-item">
            <img src="@/assets/images/3.jpeg" alt="ModernKurs Merkezi 3" class="gallery-image">
          </div>
          <div class="gallery-item">
            <img src="@/assets/images/4.jpeg" alt="ModernKurs Merkezi 4" class="gallery-image">
          </div>
        </div>
      </div>
    </section>

    <!-- About Section -->
    <section class="about-section">
      <div class="container">
        <div class="about-content">
          <div class="about-text">
            <h2>Modern Kurs Hakkında</h2>
            <p>Modern Kurs, eğitimde kaliteyi ve yeniliği bir araya getiren, öğrencilerin potansiyellerini en üst düzeye çıkarmalarına yardımcı olan bir eğitim kurumudur.</p>
            <p>Gelişmiş randevu sistemi, öğrenci takibi ve detaylı raporlama özelliklerimiz ile eğitim yönetimi artık çok daha kolay ve etkili.</p>
            <div class="about-stats">
              <div class="stat-item">
                <div class="stat-number">500+</div>
                <div class="stat-label">Mevcut Öğrenci</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">40+</div>
                <div class="stat-label">Personel </div>
              </div>
              <div class="stat-item">
                <div class="stat-number">5+</div>
                <div class="stat-label">Yıl Deneyim</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Services Section -->
    <section class="services-section">
      <div class="container">
        <div class="section-header">
          <h2>🎯 Hizmetlerimiz</h2>
          <p>Eğitimde mükemmelliği hedefleyen çözümler</p>
        </div>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon">🎓</div>
            <h3>TYT-AYT Hazırlık</h3>
            <p>9-10-11-12. sınıf ve mezunlar için üniversite hazırlık</p>
          </div>
          <div class="service-card">
            <div class="service-icon">💻</div>
            <h3>Online Birebir Randevu Sistemi</h3>
            <p>Teknolojik altyapı ile uzaktan randevu imkanı</p>
          </div>
          <div class="service-card">
            <div class="service-icon">📊</div>
            <h3>Rehberlik Ve Öğrenci Koçluğu </h3>
            <p>Her öğrenci için özel gelişim planı ve takip sistemi</p>
          </div>
          <div class="service-card">
            <div class="service-icon">🏛️</div>
            <h3>Kütüphane</h3>
            <p>Sessiz çalışma ortamı</p>
          </div>
          <div class="service-card">
            <div class="service-icon">👨‍👩‍👧‍👦</div>
            <h3>Veli Bilgilendirme</h3>
            <p>Öğrenci gelişimi hakkında düzenli veli bilgilendirme sistemi</p>
          </div>
          <div class="service-card">
            <div class="service-icon">📝</div>
            <h3>Deneme Sınavı</h3>
            <p>Düzenli deneme sınavları ile öğrenci performans takibi</p>
          </div>
          <div class="service-card">
            <div class="service-icon">🎉</div>
            <h3>Etkinlikler</h3>
            <p>Eğitici ve eğlenceli sosyal etkinlikler</p>
          </div>
          <div class="service-card">
            <div class="service-icon">📈</div>
            <h3>Seri Denemeler</h3>
            <p>Yoğunlaştırılmış seri deneme sınavları</p>
          </div>
          <div class="service-card">
            <div class="service-icon">🎯</div>
            <h3>Kariyer Danışmanlığı</h3>
            <p>Uzman kariyer danışmanları ile gelecek planlaması</p>
          </div>
          <div class="service-card">
            <div class="service-icon">🎤</div>
            <h3>Konferanslar</h3>
            <p>Uzman konuşmacılar ile bilgilendirici konferanslar</p>
          </div>
          <div class="service-card">
            <div class="service-icon">📖</div>
            <h3>Ekstra Kaynak Kitap</h3>
            <p>Ek çalışma için zengin kaynak kitap seçenekleri</p>
          </div>
          <div class="service-card">
            <div class="service-icon">🌐</div>
            <h3>İnternet</h3>
            <p>Hızlı internet ile online araştırma imkanı</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section class="contact-section">
      <div class="container">
        <div class="section-header">
          <h2>📞 İletişim</h2>
          <p>Modern Kurs hakkında bilgi almak için bizimle iletişime geçin</p>
        </div>
        <div class="contact-content">
          <div class="contact-info">
            <div class="contact-item">
              <div class="contact-icon">📍</div>
              <div class="contact-details">
                <h4>Adres</h4>
                <a href="https://www.google.com/maps?q=37.461503125207315,35.82148209864696" target="_blank" class="address-link">
                  Modern Kurs Merkezi, Göç Yolu Yusuf Baysal Sitesi Edem Pastanesi Üstü, Tufanpaşa, Kozan/Adana
                </a>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">📞</div>
              <div class="contact-details">
                <h4>Telefon</h4>
                <div class="phone-numbers">
                  <a href="tel:05526833403" class="phone-link">0552 683 34 03</a>
                  <span class="phone-separator">-</span>
                  <a href="tel:05526833409" class="phone-link">0552 683 34 09</a>
                </div>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">☎️</div>
              <div class="contact-details">
                <h4>Sabit Telefon</h4>
                <a href="tel:03225150405" class="phone-link">0322 515 04 05</a>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">✉️</div>
              <div class="contact-details">
                <h4>E-posta</h4>
                <a href="mailto:modernkurs01@gmail.com" class="email-link">modernkurs01@gmail.com</a>
              </div>
            </div>
          </div>
          <div class="contact-actions">
            <router-link to="/contact" class="btn btn-primary">Detaylı İletişim</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- WhatsApp Floating Button -->
    <WhatsAppButton />

    <!-- Footer -->
    <CorporateFooter />


  </div>
</template>

<script>

import CorporateNavbar from '@/components/CorporateNavbar.vue'
import CorporateFooter from '@/components/CorporateFooter.vue'
import WhatsAppButton from '@/components/WhatsAppButton.vue'

export default {
  name: 'CorporateHome',
  components: {
    CorporateNavbar,
    CorporateFooter,
    WhatsAppButton
  },
  setup() {
    return {}
  }
}
</script>

<style scoped>
.corporate-home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: 130px;
  overflow-x: hidden;
  width: 100%;
}

/* Hero Section */
.hero-section {
  position: relative;
  min-height: 60vh;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  color: white;
  overflow: hidden;
  margin-top: 20px!important;
  flex: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
}

.hero-text {
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
}

.hero-title {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  background: linear-gradient(45deg, #fff, #f0f0f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  opacity: 0.95;
  font-weight: 300;
}

.hero-description {
  font-size: 1.2rem;
  margin-bottom: 3rem;
  opacity: 0.9;
  line-height: 1.8;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.hero-actions {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* Gallery Section */
.gallery-section {
  padding: 5rem 0;
  background: #f8f9fa;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 1rem;
  font-weight: 700;
}

.section-header p {
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.gallery-item {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  padding: 0;
  background: transparent;
}

.gallery-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  border-color: #667eea;
}

.gallery-image {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 20px;
  transition: all 0.3s ease;
  display: block;
}

.gallery-item:hover .gallery-image {
  transform: scale(1.02);
}

/* About Section */
.about-section {
  padding: 5rem 0;
  background: white;
}

.about-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.about-text h2 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 2rem;
  font-weight: 700;
}

.about-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 1.5rem;
}

.about-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3rem;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: #667eea;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1.1rem;
  color: #666;
  font-weight: 600;
}

/* Services Section */
.services-section {
  padding: 5rem 0;
  background: #f8f9fa;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  overflow-x: hidden;
  width: 100%;
}

.service-card {
  background: white;
  padding: 2.5rem 2rem;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
}

.service-card h3 {
  font-size: 1.3rem;
  color: #2c3e50;
  margin-bottom: 1rem;
  font-weight: 600;
}

.service-card p {
  color: #666;
  line-height: 1.6;
}

/* Contact Section */
.contact-section {
  padding: 5rem 0;
  background: white;
}

.contact-content {
  max-width: 800px;
  margin: 0 auto;
}

.contact-info {
  display: grid;
  gap: 2rem;
  margin-bottom: 3rem;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 15px;
  transition: transform 0.3s ease;
}

.contact-item:hover {
  transform: translateY(-3px);
}

.contact-icon {
  font-size: 2rem;
  color: #667eea;
  flex-shrink: 0;
}

.contact-details h4 {
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
  font-weight: 600;
}

.contact-details p,
.contact-details .email-link {
  color: #555;
  line-height: 1.6;
  margin: 0;
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-details .email-link:hover {
  color: #667eea;
  text-decoration: underline;
  transform: translateY(-1px);
}

.address-link {
  color: #555;
  text-decoration: none;
  line-height: 1.6;
  margin: 0;
  transition: color 0.3s ease;
  cursor: pointer;
}

.address-link:hover {
  color: #667eea;
  text-decoration: underline;
}

.phone-numbers {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.phone-separator {
  color: #999;
  font-weight: 400;
  font-size: 0.9rem;
}

.phone-link {
  color: #555;
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
}

.phone-link:hover {
  color: #667eea;
  text-decoration: underline;
}

.contact-actions {
  text-align: center;
}

/* Buttons */
.btn {
  display: inline-block;
  padding: 15px 30px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  cursor: pointer;
  text-align: center;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(102, 126, 234, 0.5);
}

.btn-outline {
  background: transparent;
  color: white;
  border-color: white;
}

.btn-outline:hover {
  background: white;
  color: #2c3e50;
  transform: translateY(-3px);
}



/* Container */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  overflow-x: hidden;
  width: 100%;
}

/* Services Section */
.services-section {
  padding: 5rem 0;
  background: #f8f9fa;
  overflow-x: hidden;
  width: 100%;
}

/* Responsive */
@media (max-width: 1200px) {
  .container {
    max-width: 1000px;
    padding: 0 2rem;
    overflow-x: hidden;
  }
  
  .services-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
    overflow-x: hidden;
    width: 100%;
  }
  
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .container {
    max-width: 100%;
    padding: 0 1.5rem;
    overflow-x: hidden;
  }
  
  .corporate-home {
    margin-top: 110px;
    overflow-x: hidden;
  }
  
  .hero-section {
    margin-top: 10px;
    overflow-x: hidden;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-subtitle {
    font-size: 1.3rem;
  }
  
  .gallery-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
    overflow-x: hidden;
  }
  
  .about-stats {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    overflow-x: hidden;
    width: 100%;
    padding: 0 1rem;
  }
  
  .service-card {
    padding: 2rem 1.5rem;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
  }
  
  .contact-item {
    flex-direction: column;
    text-align: left;
  }
  
  .contact-details {
    text-align: left;
  }
  
  .contact-details h4 {
    text-align: left;
  }
  
  .contact-details p {
    text-align: left;
  }
  
  .phone-numbers {
    justify-content: flex-start;
  }
  
  .hero-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .service-icon {
    font-size: 2.5rem;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2rem;
  }
  
  .contact-item {
    text-align: left;
  }
  
  .contact-details {
    text-align: left;
  }
  
  .contact-details h4 {
    text-align: left;
  }
  
  .contact-details p {
    text-align: left;
  }
  
  .phone-numbers {
    justify-content: flex-start;
  }
  
  .container {
    padding: 0 1rem;
    overflow-x: hidden;
  }
  
  .corporate-home {
    margin-top: 100px;
    overflow-x: hidden;
  }
  
  .hero-section {
    margin-top: 5px;
    overflow-x: hidden;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    overflow-x: hidden;
    width: 100%;
    padding: 0 0.5rem;
  }
  
  .service-card {
    padding: 1.5rem 1rem;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
  }
  
  .gallery-grid {
    grid-template-columns: 1fr;
    overflow-x: hidden;
  }
  
  .modal-overlay {
    padding: 1rem;
  }
}
</style>
